module.exports = __webpack_public_path__ + "img/top2.247690a1.svg";